/* eslint-disable @typescript-eslint/no-unused-vars */
import { motion } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';

import ItemRanking from './ItemRanking';

import { Paginator } from '@/components/Paginator';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { ResponseVerFechaOro } from '@/types/goldDate';
import { Equipo } from '@/types/tda';
import { FADE_IN_OUT } from '@/utils';

const RankingTable = (props: ResponseVerFechaOro | null) => {
  const { isDesktop, isMobile } = useIsDesktop();
  const [dataTable, setDataTable] = useState<Equipo[]>([]);
  const [contentCurrentPage, setContentCurrentPage] = useState<Equipo[]>([]);

  useEffect(() => {
    if (props) {
      setDataTable(props.top_fecha);
    }
  }, [props]);

  const initState = useCallback(() => {
    if (dataTable.length > 0 && isDesktop) {
      setContentCurrentPage(dataTable.slice(0, 10));
    } else {
      setContentCurrentPage(dataTable);
    }
  }, [isDesktop, dataTable]);

  useEffect(() => {
    initState();

    return () => {
      setContentCurrentPage([]);
    };
  }, [initState]);

  const handleContentCurrentPage = (dts: Equipo[]) => {
    dts && setContentCurrentPage(dts);
  };

  return (
    <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto">
      <div className="flex text-gdt-gray-4 font-bold text-xs lg:text-sm h-10 mt-4 lg:mt-5 items-center px-7 bg-transparent">
        <p className="w-12 lg:w-[68px]">{isDesktop ? 'Posición' : 'Pos'}</p>
        <p className="flex-1">DT</p>
        <p className="w-[62px] text-right lg:w-[113px] lg:text-center">
          Puntos
        </p>
      </div>
      {dataTable && dataTable.length > 0 && (
        <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
          <>
            <div className="lg:h-auto rounded-lg bg-white overflow-hidden">
              {isDesktop &&
                contentCurrentPage.map((item: Equipo, index: number) => {
                  return (
                    <ItemRanking
                      key={index + item.dt}
                      data={item}
                      isFinal={props?.algunaFechaDelTAPublicada}
                    />
                  );
                })}
              {isDesktop && dataTable.length > 0 && (
                <>
                  <Paginator
                    key={dataTable
                      .map((item) => item.nroPos + item.puntos)
                      .join('.')}
                    currentContentPage={handleContentCurrentPage}
                    items={dataTable}
                  />
                </>
              )}
              {isMobile &&
                dataTable.map((item: Equipo, index: number) => {
                  return (
                    <ItemRanking
                      key={index + item.dt}
                      data={item}
                      isFinal={props?.algunaFechaDelTAPublicada}
                    />
                  );
                })}
            </div>
          </>
        </motion.div>
      )}
    </div>
  );
};

export default RankingTable;
